module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-content"
  }, [_c('div', {
    staticClass: "jin-main"
  }, [(_vm.isType) ? _c('CVideoForType') : _vm._e(), _vm._v(" "), _c('c-video'), _vm._v(" "), _c('related-recommend')], 1), _vm._v(" "), _c('c-side', {
    ref: "side"
  }, [(_vm.isTrading) ? _c('c-trading-notice', {
    on: {
      "update": _vm.updateTradingNotice
    }
  }) : _c('c-notice')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4d678b8","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tv/modules/Content/src/main.vue
// module id = KVJS
// module chunks = 2 3 4 6 7 8 9